<template>
  <div class="upload-box">
    <el-upload
      ref="upload"
      action=""
      class="avatar-uploader"
      :list-type="listType"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :accept="accept"
      :http-request="toUpload"
      :disabled="disabled"
      :multiple="false"
      :limit="1"
      :on-exceed="handleExceed"
      :show-file-list="false"
    >
      <el-button type="primary" :disabled="disabled || uploading">{{
        uploading ? "上传中..." : "上传"
      }}</el-button>
    </el-upload>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PdfUpload",
  props: {
    // 图片集合
    fileList: {
      //绑定已上传的文件列表（受控模式）
      type: Array,
      required: true,
    },
    // id集合字符串格式
    imgIdOld: {
      type: String,
      default: "",
    },
    // 上传格式，text,picture,picture-card
    listType: {
      type: String,
      default: "text",
    },
    // 文件格式限制
    accept: {
      type: String,
      default: "application/pdf",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      // dialogVisible: false,
      isLimit: true,
      imgArr: [],
      delIndex: "",
      hideUpload: false,

      ossSignature: {},
      limitType: false,
      uploading: false,
    };
  },
  created() {
    // console.log(this.id)
  },
  mounted() {},
  //方法集合
  methods: {
    handleExceed() {
      // 清空已有文件
      this.$emit("update:fileList", []);
    },
    beforeUpload(file) {
      // 验证文件类型
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        this.$message.error("只能上传PDF文件!");
        return false;
      }
      const isLt20M = file.size / 1024 / 1024 <= 20;
      if (!isLt20M) {
        this.$message.error("文件大小不能超过20MB!");
        return false;
      }
      return true;
    },
    toUpload(data) {
      this.uploading = true;
      const formdata = new FormData();
      formdata.append("file", data.file);
      formdata.append("module", "tp");

      // const httpUrl = "https://demo.lingximind.com/lx_oss/file/upload/v2";
      const httpUrl = "https://lingximind.com/lx_oss/file/upload/v2";

      axios({
        url: httpUrl,
        method: "post",
        data: formdata,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          this.uploading = false;

          if (res.data.code === 0) {
            const newFile = {
              url: res.data.msg,
              fileName: data.file.name,
            };
            // 使用emit更新fileList
            this.$emit("update:fileList", [newFile]);
            this.$emit("getFileList", [newFile]);
            this.$message.success("上传成功");
          } else if (res.data.code === 1000) {
            this.$message.error(res.data.msg);
            this.$store.dispatch("user/logout");
            this.$router.push(`/login`);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.uploading = false;
          this.$message.error("上传失败，请重试");
          console.error("Upload error:", err);
        });
    },
  },
  watch: {
    fileList: {
      handler(newVal) {
        if (newVal) {
          this.imgArr = newVal.map((item) => item.id).filter(Boolean);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less">
// 重置基础样式
.upload-box {
  font-size: 14px !important; // 使用!important确保覆盖继承的样式
  line-height: 1.5 !important;
  display: inline-block;
  margin-left: 10px;

  :deep(.el-upload--text) {
    margin-left: 0;
  }

  :deep(.el-upload-list__item.is-ready) {
    display: none;
  }

  :deep(.el-upload-list--text) {
    display: none;
  }

  :deep(.el-button--mini) {
    padding: 7px 15px;
    font-size: 12px;
  }

  .avatar-uploader {
    display: inline-block;

    :deep(.el-upload) {
      display: inline-block;
      border: none;
    }

    :deep(.el-button) {
      font-size: 12px;
    }
  }
}

:deep(.el-upload-list) {
  display: none;
}
</style>
